export default __webpack_public_path__ + "static/media/plsql.3cae61a7.png";